import { fromJS } from 'immutable';
import { basicSort } from '../../../../util/sortUtils';

import {
  tsuVisibleColumns,
  refVisibleColumns,
  tsuSort,
  refSort,
} from '../../../EditReduxConstant';

export const CLEAR_EDIT_DEPOSIT = 'CLEAR_EDIT_DEPOSIT';

export const GET_EDIT_DEPOSIT_REQUEST = 'GET_EDIT_DEPOSIT_REQUEST';
export const GET_EDIT_DEPOSIT_SUCCESS = 'GET_EDIT_DEPOSIT_SUCCESS';
export const GET_EDIT_DEPOSIT_FAILURE = 'GET_EDIT_DEPOSIT_FAILURE';

export const UPDATE_EDIT_DEPOSIT_REQUEST = 'UPDATE_EDIT_DEPOSIT_REQUEST';
export const UPDATE_EDIT_DEPOSIT_SUCCESS = 'UPDATE_EDIT_DEPOSIT_SUCCESS';
export const UPDATE_EDIT_DEPOSIT_FAILURE = 'UPDATE_EDIT_DEPOSIT_FAILURE';

export const CREATE_EDIT_DEPOSIT_REQUEST = 'CREATE_EDIT_DEPOSIT_REQUEST';
export const CREATE_EDIT_DEPOSIT_SUCCESS = 'CREATE_EDIT_DEPOSIT_SUCCESS';
export const CREATE_EDIT_DEPOSIT_FAILURE = 'CREATE_EDIT_DEPOSIT_FAILURE';

export const EDIT_DEPOSIT_TSUNAMI_SEARCH_REQUEST = 'EDIT_DEPOSIT_TSUNAMI_SEARCH_REQUEST';
export const EDIT_DEPOSIT_TSUNAMI_SEARCH_SUCCESS = 'EDIT_DEPOSIT_TSUNAMI_SEARCH_SUCCESS';
export const EDIT_DEPOSIT_TSUNAMI_SEARCH_FAILURE = 'EDIT_DEPOSIT_TSUNAMI_SEARCH_FAILURE';

export const EDIT_DEPOSIT_TSUNAMI_REQUEST = 'EDIT_DEPOSIT_TSUNAMI_REQUEST';
export const EDIT_DEPOSIT_TSUNAMI_SUCCESS = 'EDIT_DEPOSIT_TSUNAMI_SUCCESS';
export const EDIT_DEPOSIT_TSUNAMI_FAILURE = 'EDIT_DEPOSIT_TSUNAMI_FAILURE';

export const EDIT_DEPOSIT_PUBLICATIONS_REQUEST = 'EDIT_DEPOSIT_PUBLICATIONS_REQUEST';
export const EDIT_DEPOSIT_PUBLICATIONS_SUCCESS = 'EDIT_DEPOSIT_PUBLICATIONS_SUCCESS';
export const EDIT_DEPOSIT_PUBLICATIONS_FAILURE = 'EDIT_DEPOSIT_PUBLICATIONS_FAILURE';

export const EDIT_DEPOSIT_EVENT_REQUEST = 'EDIT_DEPOSIT_EVENT_REQUEST';
export const EDIT_DEPOSIT_EVENT_SUCCESS = 'EDIT_DEPOSIT_EVENT_SUCCESS';
export const EDIT_DEPOSIT_EVENT_FAILURE = 'EDIT_DEPOSIT_EVENT_FAILURE';

export const EDIT_DEPOSIT_GEOLOGIC_AGE_REQUEST = 'EDIT_DEPOSIT_GEOLOGIC_AGE_REQUEST';
export const EDIT_DEPOSIT_GEOLOGIC_AGE_SUCCESS = 'EDIT_DEPOSIT_GEOLOGIC_AGE_SUCCESS';
export const EDIT_DEPOSIT_GEOLOGIC_AGE_FAILURE = 'EDIT_DEPOSIT_GEOLOGIC_AGE_FAILURE';

export const EDIT_DEPOSIT_REFERENCE_REQUEST = 'EDIT_DEPOSIT_REFERENCE_REQUEST';
export const EDIT_DEPOSIT_REFERENCE_SUCCESS = 'EDIT_DEPOSIT_REFERENCE_SUCCESS';
export const EDIT_DEPOSIT_REFERENCE_FAILURE = 'EDIT_DEPOSIT_REFERENCE_FAILURE';

export const EDIT_DEPOSIT_REFERENCE_SEARCH_REQUEST = 'EDIT_DEPOSIT_REFERENCE_SEARCH_REQUEST';
export const EDIT_DEPOSIT_REFERENCE_SEARCH_SUCCESS = 'EDIT_DEPOSIT_REFERENCE_SEARCH_SUCCESS';
export const EDIT_DEPOSIT_REFERENCE_SEARCH_FAILURE = 'EDIT_DEPOSIT_REFERENCE_SEARCH_FAILURE';

export const EDIT_DEPOSIT_COUNTRY_REQUEST = 'EDIT_DEPOSIT_COUNTRY_REQUEST';
export const EDIT_DEPOSIT_COUNTRY_SUCCESS = 'EDIT_DEPOSIT_COUNTRY_SUCCESS';
export const EDIT_DEPOSIT_COUNTRY_FAILURE = 'EDIT_DEPOSIT_COUNTRY_FAILURE';

export const EDIT_DEPOSIT_LOCATION_NAME_REQUEST = 'EDIT_DEPOSIT_LOCATION_NAME_REQUEST';
export const EDIT_DEPOSIT_LOCATION_NAME_SUCCESS = 'EDIT_DEPOSIT_LOCATION_NAME_SUCCESS';
export const EDIT_DEPOSIT_LOCATION_NAME_FAILURE = 'EDIT_DEPOSIT_LOCATION_NAME_FAILURE';

export const EDIT_DEPOSIT_BODY_OF_WATER_REQUEST = 'EDIT_DEPOSIT_BODY_OF_WATER_REQUEST';
export const EDIT_DEPOSIT_BODY_OF_WATER_SUCCESS = 'EDIT_DEPOSIT_BODY_OF_WATER_SUCCESS';
export const EDIT_DEPOSIT_BODY_OF_WATER_FAILURE = 'EDIT_DEPOSIT_BODY_OF_WATER_FAILURE';

export const EDIT_DEPOSIT_REFERENCE_SORT = 'EDIT_DEPOSIT_REFERENCE_SORT';
export const EDIT_DEPOSIT_TSUNAMI_SORT = 'EDIT_DEPOSIT_TSUNAMI_SORT';

export const EDIT_DEPOSIT_OPEN_CONFIRMATION = 'EDIT_DEPOSIT_OPEN_CONFIRMATION';
export const EDIT_DEPOSIT_CANCEL_CONFIRMATION = 'EDIT_DEPOSIT_CANCEL_CONFIRMATION';

export const EDIT_DEPOSIT_REFERENCE_TOGGLE_COLUMN = 'EDIT_DEPOSIT_REFERENCE_TOGGLE_COLUMN';
export const EDIT_DEPOSIT_TSUNAMI_TOGGLE_COLUMN = 'EDIT_DEPOSIT_TSUNAMI_TOGGLE_COLUMN';


const initialState = fromJS({
  fetched: false,
  deposit: {
    tsunamiEventIds: [],
  },
  updating: false,

  tsunamis: [],
  fetchedTsunamis: false,
  tsunamiSearchResults: [],
  tsunamiSearching: false,

  fetchedReference: false,
  reference: [],
  referenceSearchResults: [],
  referenceSearching: false,

  fetchedEvents: false,
  events: [],
  fetchedCountries: false,
  countries: [],
  fetchedLocationNames: false,
  locationNames: [],
  fetchedGeologicAges: false,
  geologicAges: [],
  fetchedBodyOfWater: false,
  bodyOfWater: [],
  fetchedPublications: false,
  publications: [],

  tsuSort,
  refSort,
  tsuVisibleColumns,
  refVisibleColumns,
  formData: {},
  editConfirmationOpen: false,

});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const depositEditReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_EDIT_DEPOSIT:
      return initialState;

    case EDIT_DEPOSIT_OPEN_CONFIRMATION:
      return state.merge(fromJS({
        formData: action.formData,
        editConfirmationOpen: true,
      }));
    case EDIT_DEPOSIT_CANCEL_CONFIRMATION:
      return state.merge(fromJS({
        formData: {},
        editConfirmationOpen: false,
      }));

    case GET_EDIT_DEPOSIT_REQUEST:
      return state.merge(fromJS({
        fetched: false,
        updating: false,
      }));
    case CREATE_EDIT_DEPOSIT_REQUEST:
    case UPDATE_EDIT_DEPOSIT_REQUEST:
      return state.merge(fromJS({
        fetched: false,
        updating: true,
      }));
    case CREATE_EDIT_DEPOSIT_SUCCESS:
    case UPDATE_EDIT_DEPOSIT_SUCCESS:
      return state.merge(fromJS({
        fetched: true,
        deposit: action.response,
        updating: false,
        formData: {},
        editConfirmationOpen: false,
      }));
    case GET_EDIT_DEPOSIT_SUCCESS:
      return state.merge(fromJS({
        fetched: true,
        deposit: action.response,
        updating: false,
      }));
    case CREATE_EDIT_DEPOSIT_FAILURE:
    case UPDATE_EDIT_DEPOSIT_FAILURE:
      return state.merge(fromJS({
        fetched: false,
        updating: false,
        formData: {},
        editConfirmationOpen: false,
      }));
    case GET_EDIT_DEPOSIT_FAILURE:
      return state.merge(fromJS({
        fetched: false,
        updating: false,
      }));


    case EDIT_DEPOSIT_TSUNAMI_SORT:
      return state.merge(fromJS({
        tsunamiSearchResults: basicSort(action.sort, state.get('tsunamiSearchResults')),
        tsuSort: action.sort,
      }));


    case EDIT_DEPOSIT_TSUNAMI_REQUEST:
      return state.merge(fromJS({
        fetchedTsunamis: false,
      }));
    case EDIT_DEPOSIT_TSUNAMI_SUCCESS:
      return state.merge(fromJS({
        fetchedTsunamis: true,
        tsunamis: action.response.items,
      }));
    case EDIT_DEPOSIT_TSUNAMI_FAILURE:
      return state.merge(fromJS({
        fetchedTsunamis: true,
      }));

    case EDIT_DEPOSIT_TSUNAMI_SEARCH_REQUEST:
      return state.merge(fromJS({
        tsunamiSearching: true,
      }));
    case EDIT_DEPOSIT_TSUNAMI_SEARCH_SUCCESS:
      return state.merge(fromJS({
        tsunamiSearching: false,
        tsunamiSearchResults: basicSort(state.get('tsuSort'), fromJS(action.response.items)),
      }));
    case EDIT_DEPOSIT_TSUNAMI_SEARCH_FAILURE:
      return state.merge(fromJS({
        tsunamiSearching: false,
      }));


    case EDIT_DEPOSIT_REFERENCE_SORT:
      return state.merge(fromJS({
        referenceSearchResults: basicSort(action.sort, state.get('referenceSearchResults')),
        refSort: action.sort,
      }));

    case EDIT_DEPOSIT_REFERENCE_REQUEST:
      return state.merge(fromJS({
        fetchedReference: false,
      }));
    case EDIT_DEPOSIT_REFERENCE_SUCCESS:
      return state.merge(fromJS({
        fetchedReference: true,
        reference: action.response.items,
      }));
    case EDIT_DEPOSIT_REFERENCE_FAILURE:
      return state.merge(fromJS({
        fetchedReference: true,
      }));

    case EDIT_DEPOSIT_REFERENCE_SEARCH_REQUEST:
      return state.merge(fromJS({
        referenceSearching: true,
      }));
    case EDIT_DEPOSIT_REFERENCE_SEARCH_SUCCESS:
      return state.merge(fromJS({
        referenceSearching: false,
        referenceSearchResults: basicSort(state.get('refSort'), fromJS(action.response.items)),
      }));
    case EDIT_DEPOSIT_REFERENCE_SEARCH_FAILURE:
      return state.merge(fromJS({
        referenceSearching: false,
      }));

    case EDIT_DEPOSIT_COUNTRY_REQUEST:
      return state.merge(fromJS({
        fetchedCountries: false,
      }));
    case EDIT_DEPOSIT_COUNTRY_SUCCESS:
      return state.merge(fromJS({
        fetchedCountries: true,
        countries: action.response.items,
      }));
    case EDIT_DEPOSIT_COUNTRY_FAILURE:
      return state.merge(fromJS({
        fetchedCountries: true,
      }));


    case EDIT_DEPOSIT_LOCATION_NAME_REQUEST:
      return state.merge(fromJS({
        fetchedLocationNames: false,
      }));
    case EDIT_DEPOSIT_LOCATION_NAME_SUCCESS:
      return state.merge(fromJS({
        fetchedLocationNames: true,
        locationNames: action.response.items,
      }));
    case EDIT_DEPOSIT_LOCATION_NAME_FAILURE:
      return state.merge(fromJS({
        fetchedLocationNames: true,
      }));

    case EDIT_DEPOSIT_GEOLOGIC_AGE_REQUEST:
      return state.merge(fromJS({
        fetchedGeologicAges: false,
      }));
    case EDIT_DEPOSIT_GEOLOGIC_AGE_SUCCESS:
      return state.merge(fromJS({
        fetchedGeologicAges: true,
        geologicAges: action.response.items,
      }));
    case EDIT_DEPOSIT_GEOLOGIC_AGE_FAILURE:
      return state.merge(fromJS({
        fetchedGeologicAges: true,
      }));

    case EDIT_DEPOSIT_EVENT_REQUEST:
      return state.merge(fromJS({
        fetchedEvents: false,
      }));
    case EDIT_DEPOSIT_EVENT_SUCCESS:
      return state.merge(fromJS({
        fetchedEvents: true,
        events: action.response.items,
      }));
    case EDIT_DEPOSIT_EVENT_FAILURE:
      return state.merge(fromJS({
        fetchedEvents: true,
      }));

    case EDIT_DEPOSIT_BODY_OF_WATER_REQUEST:
      return state.merge(fromJS({
        fetchedBodyOfWater: false,
      }));
    case EDIT_DEPOSIT_BODY_OF_WATER_SUCCESS:
      return state.merge(fromJS({
        fetchedBodyOfWater: true,
        bodyOfWater: action.response.items,
      }));
    case EDIT_DEPOSIT_BODY_OF_WATER_FAILURE:
      return state.merge(fromJS({
        fetchedBodyOfWater: true,
      }));

    case EDIT_DEPOSIT_PUBLICATIONS_REQUEST:
      return state.merge(fromJS({
        fetchedPublications: false,
      }));
    case EDIT_DEPOSIT_PUBLICATIONS_SUCCESS:
      return state.merge(fromJS({
        fetchedPublications: true,
        publications: action.response.items,
      }));
    case EDIT_DEPOSIT_PUBLICATIONS_FAILURE:
      return state.merge(fromJS({
        fetchedPublications: true,
      }));

    case EDIT_DEPOSIT_REFERENCE_TOGGLE_COLUMN:
      return state.merge(fromJS({
        refVisibleColumns: action.visibleColumns,
      }));

    case EDIT_DEPOSIT_TSUNAMI_TOGGLE_COLUMN:
      return state.merge(fromJS({
        tsuVisibleColumns: action.visibleColumns,
      }));

    default:
      return state;
  }
};
